import {AthleteProfileSearchPageProps} from "./types";
import {Table} from "@digdir/designsystemet-react";
import {AthletePageTeaser} from "@/components/page-teaser/athlete-page-teaser";

export function AthleteProfileSearchPage(initial: AthleteProfileSearchPageProps) {


    return (
        <div className="layout-container flex flex-col gap-5 pb-20">
            <h1 className={"mb-0"}>{initial.heading}</h1>

            <AthletePageTeaser profiles={initial.subContent} hideImages={initial.hideImages}/>

            {initial.trainers?.length > 0 && (
                <section className={"pt-10"}>
                    <h2>Trenere</h2>
                    <Table>
                        <Table.Head className={"border-b-2"}>
                            <Table.Row>
                                <Table.HeaderCell>
                                    Navn
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                    Distrikt
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Head>
                        <Table.Body>
                            {initial.trainers.map((person) => (
                                <Table.Row className="border-b">
                                    <Table.Cell>{person.name}</Table.Cell>
                                    <Table.Cell>{person.districtName}</Table.Cell>
                                </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>
                </section>
            )}
        </div>
    )
}
